import { Text } from "@simplybusiness/mobius";
import type { TradeSelectorOptionProps } from "./types";

export function TradeSelectorOption({
  option: { value, definition },
}: TradeSelectorOptionProps) {
  return (
    <>
      <Text variant="h4">{value}</Text>
      {definition && <Text>{definition}</Text>}
    </>
  );
}
